
const AgencyDefaults = props => {

  //console.log(props)
  const {
    value,
  } = props

  const certTemplate = value.tgbl_cred_agency_is_cert_plugin_activated && (
    <div className="tgbl-agency-certificate-template tgbl-field-block">
      { tangibleFields.render({
          type: 'combo-box',
          name: 'tgbl_cred_agency_certificate_template',
          value: value.tgbl_cred_agency_certificate_template,
          label: 'Default Certificate Template',
          description:
            'The default PHP certificate template for new accreditations associated with this agency. This can be modified per accreditation as needed.',
          isAsync: true,
          ajaxAction: 'tgbl_content_type_items',
          asyncArgs: {
            content_type: 'tgbl-certificate'
          },
      }) }
    </div>
  );

  const enableProductId = tangibleFields.render({
    type: 'switch',
    name: 'tgbl_cred_agency_enable_product_id',
    value: value.tgbl_cred_agency_enable_product_id,
    value_on: 0,
    value_off: 1,
    label: 'Enable Product ID',
    description: 'Enables Accreditation-specific codes for this Agency that will not be saved to completion events. This represents the accrediting agency\'s internal ID for this  accreditation. This is especially useful   for API or CSV reporting.',
  })


  const enableAccreditationCode = tangibleFields.render({
    type: 'switch',
    name: 'tgbl_cred_agency_enable_accreditation_code',
    value: value.tgbl_cred_agency_enable_accreditation_code,
    value_on: 0,
    value_off: 1,
    label: 'Enable Accreditation Code',
    description: 'Enables Accreditation-specific codes and allows customization of label text. This code will be saved to completion events, and represents the accrediting agency\'s acknowledgement of this accreditation.',
  })

  const enableAccreditationCodeLabel = tangibleFields.render({
    type: 'text',
    name: 'tgbl_cred_agency_accreditation_code_label',
    value: value.tgbl_cred_agency_accreditation_code_label,
    label: 'Enable Accreditation Code Label',
  })

  const enableVariableAccreditationCodes = tangibleFields.render({
    type: 'switch',
    name: 'tgbl_cred_agency_enable_variable_accreditation_codes',
    value: value.tgbl_cred_agency_enable_variable_accreditation_codes,
    value_on: 0,
    value_off: 1,
    label: 'Enable Variable Accreditation Codes',
    description: 'Use this if the accreditation requires different codes for different time-frames.',
  })
  
  return (
    <>
      { certTemplate }

      <div className="tgbl-agency-enable-product-id tgbl-field-block">
        { enableProductId }
      </div>

      <div className="tgbl-agency-enable-accreditation-code tgbl-field-block">
        { enableAccreditationCode }
      </div>

      <div className="tgbl-agency-enable-accreditation-code-label tgbl-field-block">
        { enableAccreditationCodeLabel }
      </div>

      <div className="tgbl-agency-enable-variable-accreditation-codes tgbl-field-block">
        { enableVariableAccreditationCodes }
      </div>
    </>
  )
}

export { AgencyDefaults }
